<template>
    <ul class="navigation-menu">
        <li>
            <router-link tag="a" :to="{name: 'home'}" :class="{current: active === 0}">
                {{$t('topbar.menu.home').toUpperCase()}}
            </router-link>
        </li>
        <concept-menu-mobile v-if="!loading" />
        <suites-menu-mobile v-if="!loading" />
        <li>
            <router-link tag="a" :to="{name: 'extras'}" :class="{current: active === 3}">
                {{$t('topbar.menu.extras').toUpperCase()}}
            </router-link>
        </li>
        <li>
            <a :href="`https://blog.mihotel.fr/${blogLang}`" target="_blank">
                {{$t('topbar.menu.blog').toUpperCase()}}
            </a>
        </li>
        <li>
            <a :href="`https://reviews.customer-alliance.com/hotel/mihotel-lyon-5bfb41e46b59b2cf.html?_locale=${lang}`"
               target="_blank">{{$t('topbar.menu.advices').toUpperCase()}}
            </a>
        </li>
<!--      <li>-->
<!--        <a :href="`${salonUrl}?locale=${lang}`"-->
<!--           target="_blank">{{$t('topbar.menu.salon').toUpperCase()}}-->
<!--        </a>-->
<!--      </li>-->
        <li class="offrebusiness promote">
            <a href="https://ressources.mihotel.fr/hotel-voyage-d-affaires-lyon" target="_blank">{{$t('topbar.menu.business').toUpperCase()}}</a>
        </li>
    </ul>
</template>

<script>
    import {mapState} from "vuex";
    import ConceptMenuMobile from "./concept-menu-mobile";
    import SuitesMenuMobile from "./suites-menu-mobile";
    import NetworkUrls from "../../network/network-urls";
    export default {
        name: "mobile-navigation",
        components: {SuitesMenuMobile, ConceptMenuMobile},
        computed: {
            ...mapState({
                loading: s => s.menu.loading,
                active: s => s.menu.indexActive,
                lang: s => (s.lang.currentLang || 'fr').toLowerCase(),
              blogLang: s => {
                const lang = (s.lang.currentLang || 'fr').toLowerCase();
                if (lang === 'fr') return '';
                return lang;
              }
            })
        },
      data() {
          return {
            salonUrl: NetworkUrls.salonUrl
          }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/topbar/mobile-navigation.vue